export const routesTanitim = [
  {
    path: "/paket_tanitim",
    name: "paket_tanitim",
    component: () => import("@/views/tanitim/paket_tanitim/index.vue"),
    meta: {
      public: false,
      title: "Paket Tanıtım",
      yetki: { k: [], s: true },
    },
  },
  {
    path: "/dugun_etkinlik_tanitim",
    name: "dugun_etkinlik_tanitim",
    component: () => import("@/views/tanitim/dugun_tanitim/index.vue"),
    meta: {
      public: false,
      title: "Düğün/Etkinlik",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/etkinlik",
    name: "etkinlik",
    component: () => import("@/views/etkinlik/index.vue"),
    meta: {
      public: false,
      title: "Etkinlik",
      yetki: { k: [1010002] },
    },
  },
]
